import './index.css';
import './assets/theme.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { i18n } from './locales/i18n';

import App from './App.vue';
import router from './router';

import Notifications from '@kyvg/vue3-notification';
import { createPlayerMemberIdCookieFromUrl } from './utils/playerLoginCookie';
import { initDash0 } from './utils/dash0';

initDash0();

createPlayerMemberIdCookieFromUrl();

/** Hovr GuestCentric fallback: apenas em build de produção (não em `npm run dev`). */
const injectHovrGuestCentricFallback = () => {
  if (!import.meta.env.PROD) {
    return;
  }

  localStorage.setItem('runGuestCentricFallback', 'true');

  const script = document.createElement('script');
  script.defer = true;
  script.src = 'https://script.gethovr.com/bundle.js';
  document.head.appendChild(script);
};

injectHovrGuestCentricFallback();

const app = createApp(App);

app.use(createPinia());
app.use(i18n);
app.use(router);
app.use(Notifications);
app.mount('#app');
